export const getApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '800380168cmshe6741ca9d3e413ap1e8780jsn4f551be94d31',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo'

export const weatherOptions = {


		method: 'GET',
		headers: {
			'X-RapidAPI-Key': '800380168cmshe6741ca9d3e413ap1e8780jsn4f551be94d31',
			'X-RapidAPI-Host': 'open-weather13.p.rapidapi.com'
		}

};
export const WEATHER_API_URL = 'https://open-weather13.p.rapidapi.com'

